import React from "react";
/// React router dom
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PrivateRoute from '../PrivateRoutes'
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";


import TicketList from "../TicketList/index";
import TicketDetail from "../TicketList/ticketDetail";

import SmsList from "../Sms/index";
import SmsDetail from "../Sms/smsDetail";
import ContactList from "../contact";
import CustomerList from "../customer";
import NoteList from "../Note/index";

/// Layout
import Footer from "./layouts/Footer";
import Nav from "./layouts/nav";

/// Pages
import Error404 from "./pages/Error404";
import Login from "./pages/Login";
import LoginMobile from "./pages/LoginMobile";

import MyLocation from "./pages/MyLocation";

import LiveLocation from "./pages/LiveLocation"

const MainRoutes = () => {
  const routes = [
    { url: "/", component: TicketList },
    { url: "ticket-list", component: TicketList },
    { url: "ticket/:id", component: TicketDetail },
    { url: "sms-list", component: SmsList },
    { url: "sms/:id", component: SmsDetail },
    { url: "contact-list", component: ContactList },
    
    { url: "login", component: Login },
    { url: "my-location", component: MyLocation },
    // { url: "page-error-404", component: Error404 },
  ];

  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  let pagePath = false
  if(path == 'login'){
    pagePath = true
  }
  // let pagePath = path.split("-").includes("page");
  if (window.location.host.split(".")[0] == "trackmygear") {
    return (
    <Router>
      <Switch>
      <Route exact path="/:id" component={LiveLocation} />
      <Route component={Error404} />
      </Switch>
    </Router>
    );
  } else {
  return (
    
    <Router>
      {/* <div
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${localStorage.getItem("login") || !pagePath ? "show" : "mh100vh"} ${
          !path ? "right-profile" : ""
        }`}
      > */}
        {/* {localStorage.getItem("login") && !pagePath ?  <Nav /> : ""} */}

        {/* <div className={`${localStorage.getItem("login") && !pagePath ? "content-body" : ""}`}>
          <div
            className={`${localStorage.getItem("login") && !pagePath ? "container-fluid" : ""}`}
            style={{ minHeight: window.screen.height - 60 }}
          > */}
            <Switch>
            <Route exact path="/my-location" component={MyLocation} />
            <Route exact path="/live-location/:id" component={LiveLocation} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/check_credentials" component={LoginMobile} />
            <PrivateRoute title="Ticket" allowedRole="Ticket" exact path="/" component={TicketList}/>
            <PrivateRoute title="Ticket" allowedRole="Ticket" exact path="/ticket-list" component={TicketList}/>
            <PrivateRoute title="Ticket" allowedRole="Ticket" exact path="/ticket/:id" component={TicketDetail}/>
            <PrivateRoute title="Sms" allowedRole="Sms" exact path="/sms-list" component={SmsList}/>
            <PrivateRoute title="Sms" allowedRole="Sms" exact path="/sms/:id" component={SmsDetail}/>
            <PrivateRoute title="Contact" allowedRole="Contact" exact path="/contact-list" component={ContactList}/>
            <PrivateRoute title="Customer" allowedRole="Customer" exact path="/customer-list" component={CustomerList}/>
            <PrivateRoute title="Note" allowedRole="Note" exact path="/note-list" component={NoteList}/>
            <Route component={Error404} />
              {/* {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
                />
              ))} */}
            </Switch>
          {/* </div>
        </div> */}
       { path != "live-location" && path != "my-location" ? <Footer /> : ""}
        {/* {localStorage.getItem("login") && !pagePath && <Footer />} */}
      {/* </div> */}
    </Router>
    // <Router>
    //   <Switch>
    //  <Route exact path="/login" component={Login} />
    //  <PrivateRoute title="Ticket" allowedRole="Ticket" exact path="/" component={TicketList}/>
    //  <PrivateRoute title="Ticket" allowedRole="Ticket" exact path="/ticket-list" component={TicketList}/>
    //  <PrivateRoute title="Ticket" allowedRole="Ticket" exact path="/ticket/:id" component={TicketDetail}/>
    //  <Route component={Error404} />
    //  </Switch>
    // </Router>
  );
      }
};

export default MainRoutes;
